import { useMemo } from 'react';
import type { IntlFormatters } from 'react-intl';
import { useIntl as useReactIntl } from 'react-intl';
import type { TpMessageKeys } from './types';
export type TpFormatMessageArgs = Parameters<IntlFormatters['formatMessage']>;
export function useIntl() {
  const {
    formatMessage,
    ...rest
  } = useReactIntl();
  const typedFormatMessage = useMemo(() => (descriptor: TpFormatMessageArgs[0] & {
    id?: TpMessageKeys;
    asString?: boolean;
  }, values?: TpFormatMessageArgs[1], options?: TpFormatMessageArgs[2]) => {
    const mergedValues = {
      br: <br />,
      ...values
    };
    const message = formatMessage(descriptor, mergedValues, options);
    return descriptor.asString ? message : <span data-trans={descriptor.id}>{message}</span>;
  }, [formatMessage]);
  return {
    ...rest,
    formatMessage: typedFormatMessage,
    pureText: formatMessage
  };
}